/**
 * CrmLossReasonModal — required reason capture when an Opportunity moves to a Lost/No-Go Contract
 * Stage. Mirrors the intent of services/leads.js's disqualifyLead (LOSS_REASONS parallels
 * DISQUALIFY_REASONS), but the reason list is a real, always-visible choice here rather than the
 * Leads UI's two-hardcoded-paths shortcut — the whole point is real win/loss data.
 */
import { useState } from 'react'
import CrmModal, { F } from './CrmModal.jsx'
import { LOSS_REASONS } from '../../services/opportunities.js'

export default function CrmLossReasonModal({ stage, onClose, onConfirm }) {
  const [reason, setReason] = useState('')
  const [notes, setNotes] = useState('')
  const [saving, setSaving] = useState(false)

  async function confirm() {
    if (!reason || saving) return
    setSaving(true)
    try { await onConfirm(reason, notes) }
    finally { setSaving(false) }
  }

  const footer = (
    <>
      <button style={F.btnGhost} onClick={onClose} disabled={saving}>Cancel</button>
      <button style={{ ...F.btnPrimary, opacity: reason ? 1 : 0.5 }} onClick={confirm} disabled={!reason || saving}>
        {saving ? 'Saving…' : `Move to ${stage}`}
      </button>
    </>
  )

  return (
    <CrmModal title={`Move to ${stage}`} onClose={onClose} footer={footer} width={460}>
      <div style={F.row}>
        <label style={F.label}>Why? *</label>
        <select style={F.input} value={reason} onChange={e => setReason(e.target.value)}>
          <option value="">— Select a reason —</option>
          {LOSS_REASONS.map(r => <option key={r} value={r}>{r}</option>)}
        </select>
      </div>
      <div style={F.row}>
        <label style={F.label}>Notes (optional)</label>
        <textarea style={F.textarea} value={notes} onChange={e => setNotes(e.target.value)} placeholder="Anything worth remembering for next time?" />
      </div>
    </CrmModal>
  )
}
